import toast, { Toaster } from "react-hot-toast";
import { ApiError } from "../../lib/api/client";
import { errorMessage } from "../../lib/api/messages";

/**
 * Toasts, localized by `error.code`. One toast per code at a time (the id),
 * so a burst of failed polls shows one message, not a stack of ten.
 */
export function toastApiError(e: unknown): void {
	const id = e instanceof ApiError ? `api-${e.code}` : "api-generic";
	toast.error(errorMessage(e), { id });
}

/** `message` must already be translated. */
export function toastSuccess(message: string): void {
	toast.success(message);
}

/** Something the operator still has to act on — not a failure. `message` must already be translated. */
export function toastNotice(message: string): void {
	toast(message, { duration: 9000 });
}

export function OvrToaster() {
	return (
		<Toaster
			position="bottom-right"
			gutter={8}
			containerStyle={{ bottom: "1rem", right: "1rem" }}
			toastOptions={{
				duration: 4500,
				style: {
					fontFamily: "var(--font-sans)",
					fontSize: "0.9375rem",
					color: "var(--color-ink)",
					background: "var(--color-sheet)",
					border: "1px solid var(--color-rule)",
					borderRadius: "0.75rem",
					boxShadow: "0 0.75rem 1.5rem -0.75rem rgb(28 36 51 / 0.35)",
					padding: "0.625rem 0.875rem",
					maxWidth: "28rem",
				},
				success: { iconTheme: { primary: "var(--color-done)", secondary: "white" } },
				error: { iconTheme: { primary: "var(--color-conflict)", secondary: "white" }, duration: 7000 },
			}}
		/>
	);
}
